import React from 'react';
import { BulkUploader } from 'cccisd-laravel-nexus';

const BulkAddYouthForm = ({ loadData }) => (
    <BulkUploader
        handle="supervisorBulkYouth"
        trigger={
            <button type="button" className="btn btn-primary">
                Bulk Add Youth
            </button>
        }
        loadData={loadData}
    />
);

export default BulkAddYouthForm;
